import React, { useState } from 'react';
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";
import xor from 'lodash/xor';
import map from 'lodash/map';
import { SORT_PRICE } from '../../constants/default';
import { isMobile } from "react-device-detect";
import CheckboxList from './CheckboxList';
import './styles.scss';
import { getAllFiltersWithCounts } from '../../utils/filterUtils';

const FilterWidget = ({ dir, data = [], activeFilters, onChange, onClear, isAirport, locationSlug }) => {
  const { t, i18n } = useTranslation(); // eslint-disable-line
  const locale = i18n.language;

  const [sortKey, setSortKey] = useState(isMobile ? '1' : '0');
  const [filterKey, setFilterKey] = useState(isMobile ? '1' : '0');
  // Always extract sortPrice as a single value from array (due to normalization)
  const sortPrice = Array.isArray(activeFilters.sortPrice) ? activeFilters.sortPrice[0] : activeFilters.sortPrice;

  const changeSort = value => () => {
    onChange({ sortPrice: [value] }); // always set as array
    if (window.gtag) {
      window.gtag('event', 'Filter Changed', {
        'event_category': 'Filters',
        'event_label': 'sortPrice',
        'value': value
      });
    }
  };

  const changeParam = param => value => () => {
    let oldValue = activeFilters[param] || [];
    const newValue = xor(oldValue, [value]);
    onChange({ [param]: newValue });
    if (window.gtag) {
      window.gtag('event', 'Filter Changed', {
        'event_category': 'Filters',
        'event_label': param,
        'value': value
      });
    }
  };

  const toggleSort = () => {
    setSortKey(sortKey === '1' ? '0' : '1');
  };

  const toggleFilter = () => {
    setFilterKey(filterKey === '1' ? '0' : '1');
  };

  // Use the new utility to get all filters with counts
  const allFilters = getAllFiltersWithCounts({
    data,
    values: activeFilters,
    isAirport,
    locale
  });

  return (
    <div className="filter-section mb-3">
      <Row noGutters={true} className="mb-2">
        <Col xs={12} className="mb-2">
          <Accordion defaultActiveKey="-1" activeKey={sortKey} onSelect={toggleSort}>
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                  <svg className='mx-2' height="24" width="24" fill='#007bff' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z" /></svg>
                  {t('sortBy')}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  {SORT_PRICE.items.map(item => (
                    <Form.Check
                      dir={dir}
                      key={item.value}
                      type="radio"
                      id={item.value}
                      name="priceOrder"
                      checked={sortPrice === item.value}
                      label={t(item.title)}
                      onChange={changeSort(item.value)}
                    />
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Col>
        <Col xs={12}>
          <Accordion defaultActiveKey="-1" activeKey={filterKey} onSelect={toggleFilter}>
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                  <svg className='mx-2' height="24" width="24" fill='#007bff' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z" /></svg>
                  {t('filter')}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body className="filter-content">
                  {map(allFilters, item => (
                    <CheckboxList
                      key={item.title}
                      name={item.title}
                      element={item}
                      value={activeFilters[item.title]}
                      onChange={changeParam(item.title)}
                      locationSlug={locationSlug}
                    />
                  ))}
                    <Card.Header>
                    </Card.Header>
                    <Card.Body>
                      <Button variant="outline-primary" block onClick={onClear}>❌ {t('clearFilters')}</Button>
                    </Card.Body>

                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Col>
      </Row>
    </div>
  )
};

export default FilterWidget;
